import React from 'react';
import styled, { css } from 'styled-components';

import type { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';

type CashBackBadgeProps = {
  value: ValidIncentiveValue;
};

export const CashBackBadge = ({ value }: CashBackBadgeProps): JSX.Element => (
  <Badge data-testid='pbb-cash-back-badge'>${value} back</Badge>
);

const Badge = styled.span.withConfig({ componentId: 'cart-cash-back-badge-pill' })`
  ${({ theme: { colors } }) => css`
    background-color: var(--dcm-cart-cash-back-badge-bg, ${colors.white});
    border-radius: var(--dcm-cart-cash-back-badge-border-radius, 999px);
    color: var(--dcm-cart-cash-back-badge-text-color, ${colors.black});
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    padding: 4px 8px;
  `}
`;
